import React from 'react';
import { Link } from 'react-router-dom';

import Img from './img';

const Logo = ({ background }) => {
    const defaultLogo = 'child-poverty-logo-blue.png';
    const logoColourMap = {
        'bg-bright-blue': 'child-poverty-logo-white.png',
    };
    const image = background in logoColourMap ? logoColourMap[background] : defaultLogo;
    return (
        <Link to='/'>
            <Img filename={ image } className='w-32' />
        </Link>
    );
};

export default Logo;
